<template>
  <div id="app" v-external-link-warning>

    <div v-if="!$route.meta.public && (bypass || session.user)">
      <app-header :trans="$route.meta.transHeader" v-if="!$classicParams.embedMode" />
      <main :class="{full: $route.meta.fullMainContainer}">
        <router-view />
      </main>
    </div>

    <main v-else-if="$route.meta.public">
      <router-view />
    </main>

    <main v-else>
      <!-- Loader -->
    </main>

    <session-warning :session="session" v-if="session.user" />

  </div>
</template>

<script>

  import AppHeader from "@/components/AppHeader"
  import SessionWarning from "@/components/SessionWarning"

  export default {
    name: 'app',
    metaInfo: {
      title: "Loading...",
      titleTemplate: "%s | SyncBlasts"
    },
    components: { AppHeader, SessionWarning },
    data () {
      return {
        bypass: false,
        session: {},
      }
    },
    created () {
      if(!this.bypass) {
        this.$session.authorize(this.$classicParams.loginToken)
          .then((session) => {
            // Set session
            this.session = session
            // Pre-pop with app meta data
            let metaConfig = _.assign({
              baseURL: this.$store.adapters.http.defaults.basePath,
              url: '/metadata'
            }, this.$store.adapters.http.defaults.httpConfig)
            this.$store.adapters.http.http(metaConfig).then((response) => {
              _.each(response.data, (data, key) => {
                if(this.$store.definitions[key]) {
                  this.$store.inject(key, data)
                }
              })
            })
          })
          .catch((err) => {
            this.$router.push({name: 'logout'})
          })
      }
    }
  }

</script>

<style lang="scss" scoped>
  main {
    padding-bottom:7rem;
    &.full {
      padding-bottom:0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue